import type { CardContent, NavigationItem, TeamMember } from '../types/content'

export const navigation: NavigationItem[] = [
  { label: 'AEXION', href: '/' },
  { label: 'Produtos', href: '/produtos' },
  { label: 'Soluções', href: '/solucoes' },
  { label: 'Demos', href: '/demos' },
  { label: 'Projetos', href: '/projetos' },
  { label: 'Sobre', href: '/sobre' },
  { label: 'Contato', href: '/contato' },
]

export const games: CardContent[] = [
  { title: 'Projeto Orion', eyebrow: 'RPG · Aventura', description: 'Uma jornada épica por mundos desconhecidos.', modifier: 'card-orion', status: 'Em desenvolvimento' },
  { title: 'Projeto Atlas', eyebrow: 'Estratégia · Simulação', description: 'Construa, administre e expanda um universo dinâmico.', modifier: 'card-atlas', status: 'Em desenvolvimento' },
  { title: 'Projeto Eclipse', eyebrow: 'Terror · Psicológico', description: 'Uma experiência imersiva e inquietante.', modifier: 'card-eclipse', status: 'Em desenvolvimento' },
  { title: 'Tecnologia própria', eyebrow: 'Ferramentas · IA', description: 'Pesquisa e soluções para experiências inovadoras.', modifier: 'card-tech', status: 'Pesquisa e desenvolvimento' },
]

export const technologies: CardContent[] = [
  { title: 'Games', eyebrow: '01', description: 'Criação de jogos e universos originais.' },
  { title: 'Web', eyebrow: '02', description: 'Sites institucionais e experiências digitais.' },
  { title: 'IA', eyebrow: '03', description: 'Assistentes e ferramentas inteligentes.' },
  { title: 'Labs', eyebrow: '04', description: 'Pesquisa, testes e prototipagem.' },
]

export const team: TeamMember[] = [
  { name: 'Rafael Pio', role: 'Co-Founder', description: 'Direção criativa, design, tecnologia e desenvolvimento.', initials: 'RP' },
  { name: 'Natália', role: 'Co-Founder', description: 'Produto, estratégia, experiência educacional e criação.', initials: 'N', modifier: 'natalia' },
  { name: 'Em breve', role: 'Novos talentos', description: 'Mais pessoas poderão fazer parte dos próximos universos.', initials: '+', modifier: 'future' },
]
